<template>
    <div class="item-nav border">
      <slot name="image"></slot>
      <div class="label">{{label}}</div>
      <img class="itemNavArrowImage" src="@/assets/item-nav-arrow.png" >
    </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'

export default {
  props: {
    label: String,
    image: String,
  },
  setup(props, { emit }) {

    return {  }
  },
}
</script>

<style lang="scss">
.item-nav{
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 88px;
  padding-left: 34px;
  padding-right: 21px;
  background-color: #fff;
  .label{
    font-size: 30px;
  }
  .itemNavArrowImage{
    width: 20px;
    height: 32px;
  }
}
</style>